<template>
    <section>
        <div class="top-option-block">
            <button :class="{ 'active': typeActive === $Constants.JOB_TYPE_ORDER }" @click="setActiveOption($Constants.JOB_TYPE_ORDER)">ใบออเดอร์</button>
            <button :class="{ 'active': typeActive === $Constants.JOB_TYPE_SERVICE }" @click="setActiveOption($Constants.JOB_TYPE_SERVICE)">ใบบริการ</button>
            <button :class="{ 'active': typeActive === $Constants.JOB_TYPE_CLAIM }" @click="setActiveOption($Constants.JOB_TYPE_CLAIM)">ใบเคลม</button>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            typeActive: -1
        }
    },
    mounted() {
        this.setActiveOption(this.$Constants.JOB_TYPE_ORDER);
    },
    methods: {
        setActiveOption(type) {
            this.typeActive = type;
            this.$emit('setJobOption', type);
        }
    }
}
</script>